<template>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :success-text = "refreshSuccessText" :success-duration = "1000">
        <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="$t('financial.noMore')"
                :loading-text="$t('message.loading')"
                @load="onLoad"
        >
            <van-cell v-for="(item,index) in list" :key="index" >
                <RouterLink :to="`/Detail?id=${item.id}`">
                    <van-row class="list" >
                        <van-col span="4" class="list_ico"><van-icon name="volume-o" /></van-col>
                        <van-col span="20" class="list_c2">
                            <van-row class="list_r1">
                                <van-col span="18"><div class="van-ellipsis">{{item.title}}</div></van-col>
                                <van-col span="6"><div class="van-ellipsis">{{item.create_time | relativeTime}}</div></van-col>
                            </van-row>
                            <van-row class="list_r2">
                                <van-col span="24" class="list_r2c2">{{item.message}}</van-col>
                            </van-row>
                        </van-col>
                    </van-row>
                </RouterLink>
            </van-cell>
        </van-list>
    </van-pull-refresh>
</template>

<script>


    export default {
        name: "Maslist",
        data(){
            return{
                list: [],
                loading: false,
                finished: false,
                page:0,
                page_size:10,
                page_index:0,
                refreshing: false,
                refreshSuccessText:""
            }
        },
        props:{
          tabindex:{
              type:Number,
              required:true
          }
        },
        methods:{
            async onLoad() {
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                let res =  await this.getMessage(this.page,this.page_size,this.tabindex);
                if(res.length < this.page_size){
                    this.finished = true;
                }
                //合并数组
                this.list= this.list.concat(res);


                this.loading = false;
                this.page++;

            },
            getMessage(page,page_size,type){
                let pages = {'page':page,'page_size':page_size,'type':type};
                return new Promise((resolve, reject) => {
                    this.getReq('/getMessage', pages).then(
                        (res) => {
                            if (res.code == 200) {
                                resolve(res.data) ;

                            }
                        })
                })
            },
            async onRefresh() {

                let list = await this.getMessage(this.page,this.page_size,this.tabindex);

                if(list.length < this.page_size){
                    this.finished = true;
                }
                this.list.unshift(...list);
                this.refreshSuccessText = this.$t('financial.updatedata',{count : list.length});
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态,false关闭加载
                this.refreshing = false;
                this.page++;

            },
        }
    }
</script>

<style scoped lang="scss">
    .list {

        .list_ico {
            font-size: 22px;
            text-align: center;
            color: #ff9900;
            margin: 0 auto;
            padding-top: 10px;
        }

        .list_c2 {
            font-size: 11px;
            color: #666666;
            .list_r1{

            }
            .list_r2{
                .list_r2c2{
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }

        }
    }
</style>
